import { render, staticRenderFns } from "./Academicyear.vue?vue&type=template&id=bbe33d26&scoped=true"
import script from "./Academicyear.vue?vue&type=script&lang=js"
export * from "./Academicyear.vue?vue&type=script&lang=js"
import style0 from "./Academicyear.vue?vue&type=style&index=0&id=bbe33d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe33d26",
  null
  
)

export default component.exports